import React from 'react'
import styles from './FormFeedback.module.scss'
import classNames from 'classnames'

export interface FormFeedbackProps {
  type?: 'invalid'
  children: React.ReactNode
  className?: string
}

export const FormFeedback: React.FC<FormFeedbackProps> = ({ type = 'invalid', children, className }) => {
  const colorStyle = {
    invalid: styles.invalidFormFeedback,
  }
  return (
    <div
      className={classNames(`${colorStyle[type]}`, {
        'd-flex justify-content-end': !className,
        [`${className}`]: className,
      })}
    >
      {children}
    </div>
  )
}
